(function() {
'use strict';

var KLF_PROFESSIONAL_TRACKS = {
  'black to the future': { color:'#24315C', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/scifi_fantasy.svg?v=1788093254' },
  'coming in hot, coming of age': { color:'#BC69AC', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/ya.svg?v=1788093254' },
  'don’t go in there!': { color:'#9C3B3B', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thriller_mystery.svg?v=1788093255' },
  "don't go in there!": { color:'#9C3B3B', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thriller_mystery.svg?v=1788093255' },
  'drawn + written': { color:'#5F86A6', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/thought_bubble.svg?v=1788093254' },
  'kinfolk lit talks': { color:'#352B4B', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/KLTalksIcon.png?v=1788093255' },
  'love jones & situationships': { color:'#C75A4A', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/romance.svg?v=1788093254' },
  'our stories, our terms': { color:'#2F6E8D', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/literary_fiction.svg?v=1788093254' },
  'real life | real talk': { color:'#418066', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/podcast_nonfiction.svg?v=1788093254' },
  'real life, real talk': { color:'#418066', icon:'https://cdn.shopify.com/s/files/1/0768/0566/8909/files/podcast_nonfiction.svg?v=1788093254' }
};

function normalizeTrack(value) {
  return String(value || '').trim().toLowerCase();
}

function getModal(modalOrId) {
  if (!modalOrId) return null;
  return typeof modalOrId === 'string'
    ? document.getElementById(modalOrId)
    : modalOrId;
}

function hydrateTrackIcons(root) {
  (root || document)
    .querySelectorAll(
      '.professional-profile-modal__track-icon[data-professional-track-icon]'
    )
    .forEach(function(node) {
      if (node.dataset.trackHydrated === 'true') return;

      var config = KLF_PROFESSIONAL_TRACKS[
        normalizeTrack(
          node.getAttribute('data-professional-track-icon') || ''
        )
      ];

      if (!config || !config.icon) return;

      node.innerHTML = '';

      var mask = document.createElement('span');
      mask.className = 'professional-profile-modal__track-mask';
      mask.style.setProperty('--track-color', config.color);
      mask.style.setProperty(
        '--track-mask',
        'url("' + config.icon + '")'
      );

      node.appendChild(mask);
      node.dataset.trackHydrated = 'true';
    });
}

function moveModalsToBody() {
  document
    .querySelectorAll('[data-professional-modal]')
    .forEach(function(modal) {
      if (modal.parentElement !== document.body) {
        document.body.appendChild(modal);
      }
    });
}

function closeOtherSharedModals(exceptModal) {
  document
    .querySelectorAll('[data-professional-modal]')
    .forEach(function(modal) {
      if (modal !== exceptModal) {
        modal.hidden = true;
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
      }
    });
}

function syncBodyLock() {
  var anythingOpen = document.querySelector(
    '[data-professional-modal]:not([hidden]),' +
    '[data-author-modal].is-open,' +
    '[data-influencer-modal]:not([hidden]),' +
    '[data-catalog-modal].is-open,' +
    '[data-klf-book-modal]:not([hidden]),' +
    '[data-book-modal]:not([hidden])'
  );

  document.body.classList.toggle(
    'kinfolk-modal-open',
    Boolean(anythingOpen)
  );
}

function openModal(modalOrId, trigger) {
  var modal = getModal(modalOrId);

  if (!modal) return false;
  if (modal.getAttribute('data-profile-public') !== 'true') {
    return false;
  }

  closeOtherSharedModals(modal);

  if (trigger) {
    modal._kinfolkReturnTrigger = trigger;
  }

  modal.hidden = false;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');

  hydrateTrackIcons(modal);
  syncBodyLock();

  var dialog = modal.querySelector(
    '.professional-profile-modal__dialog'
  );

  if (dialog) {
    dialog.scrollTop = 0;

    window.setTimeout(function() {
      try {
        dialog.focus({ preventScroll:true });
      } catch (error) {
        dialog.focus();
      }
    }, 0);
  }

  return true;
}

function closeModal(modalOrId, restoreFocus) {
  var modal = getModal(modalOrId);

  if (!modal) return false;

  modal.hidden = true;
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');

  syncBodyLock();

  if (
    restoreFocus !== false &&
    modal._kinfolkReturnTrigger &&
    typeof modal._kinfolkReturnTrigger.focus === 'function'
  ) {
    try {
      modal._kinfolkReturnTrigger.focus();
    } catch (error) {}
  }

  return true;
}

function findByProfessionalProfileId(profileId) {
  if (!profileId) return null;

  var modals = document.querySelectorAll(
    '[data-professional-modal]'
  );

  for (var i = 0; i < modals.length; i++) {
    if (
      modals[i].getAttribute(
        'data-professional-profile-id'
      ) === profileId
    ) {
      return modals[i];
    }
  }

  return null;
}

function findByParticipantId(participantId) {
  if (!participantId) return null;

  var modals = document.querySelectorAll(
    '[data-professional-modal]'
  );

  for (var i = 0; i < modals.length; i++) {
    if (
      modals[i].getAttribute(
        'data-participant-id'
      ) === participantId
    ) {
      return modals[i];
    }
  }

  return null;
}

function openByProfessionalProfileId(profileId, trigger) {
  var modal = findByProfessionalProfileId(profileId);

  return modal
    ? openModal(modal, trigger || null)
    : false;
}

function openByParticipantId(participantId, trigger) {
  var modal = findByParticipantId(participantId);

  return modal
    ? openModal(modal, trigger || null)
    : false;
}

function splitDiscoveryValues(value) {
  return String(value || '')
    .split('||')
    .map(function(item) {
      return item.trim();
    })
    .filter(Boolean);
}

function getProfessionalRelationships(book, profileId) {
  var relationships = [];

  if (
    splitDiscoveryValues(
      book.dataset.editorProfileIds
    ).indexOf(profileId) !== -1
  ) {
    relationships.push('Editor');
  }

  if (
    splitDiscoveryValues(
      book.dataset.illustratorProfileIds
    ).indexOf(profileId) !== -1
  ) {
    relationships.push('Illustrator');
  }

  if (
    splitDiscoveryValues(
      book.dataset.narratorProfileIds
    ).indexOf(profileId) !== -1
  ) {
    relationships.push('Narrator');
  }

  return relationships;
}

function hydrateProfessionalBookData(modal) {
  if (
    !modal ||
    !window.KLFBookDiscovery ||
    typeof window.KLFBookDiscovery
      .getBooksForProfessionalProfile !== 'function'
  ) {
    return;
  }

  var profileId =
    modal.getAttribute(
      'data-professional-profile-id'
    ) || '';

  if (!profileId) return;

  var books =
    window.KLFBookDiscovery
      .getBooksForProfessionalProfile(profileId);

  var catalogButton =
    modal.querySelector(
      '[data-professional-catalog-button]'
    );

  var interests =
    modal.querySelector(
      '[data-professional-interests]'
    );

  if (!books.length) {
    if (catalogButton) {
      catalogButton.hidden = true;
    }

    hydrateTrackIcons(modal);
    return;
  }

  var relationships = [];
  var tracks = [];

  books.forEach(function(book) {
    getProfessionalRelationships(
      book,
      profileId
    ).forEach(function(relationship) {
      if (
        relationships.indexOf(
          relationship
        ) === -1
      ) {
        relationships.push(relationship);
      }
    });

    splitDiscoveryValues(
      book.dataset.trackNames
    ).forEach(function(track) {
      if (
        normalizeTrack(track) ===
        'kinfolk lit talks'
      ) {
        return;
      }

      if (
        !tracks.some(function(existing) {
          return (
            normalizeTrack(existing) ===
            normalizeTrack(track)
          );
        })
      ) {
        tracks.push(track);
      }
    });
  });

  if (catalogButton) {
    catalogButton.hidden = false;

    catalogButton.setAttribute(
      'data-catalog-professional-relationships',
      relationships
        .map(function(item) {
          return '||' + item + '||';
        })
        .join('')
    );
  }

  if (interests && tracks.length) {
    interests.innerHTML = '';
    interests.setAttribute(
      'aria-label',
      'Book Tracks'
    );

    tracks.forEach(function(track) {
      var icon =
        document.createElement('span');

      icon.className =
        'professional-profile-modal__track-icon ' +
        'professional-profile-modal__track-icon--large';

      icon.setAttribute(
        'data-professional-track-icon',
        track
      );

      icon.setAttribute('title', track);
      icon.setAttribute('aria-label', track);

      interests.appendChild(icon);
    });
  }

  hydrateTrackIcons(modal);
}

function hydrateAllProfessionalBookData() {
  document
    .querySelectorAll(
      '[data-professional-modal]' +
      '[data-profile-public="true"]'
    )
    .forEach(hydrateProfessionalBookData);
}

function initializeProfessionalModals() {
  moveModalsToBody();
  hydrateTrackIcons(document);

  if (
    window.KLFBookDiscovery &&
    typeof window.KLFBookDiscovery
      .whenReady === 'function'
  ) {
    window.KLFBookDiscovery.whenReady(
      hydrateAllProfessionalBookData
    );
  } else {
    document.addEventListener(
      'klf:book-discovery-ready',
      hydrateAllProfessionalBookData,
      { once:true }
    );
  }
}

window.KLFProfessionalModalOpen =
function(modalOrId, trigger) {
  return openModal(
    modalOrId,
    trigger || null
  );
};

window.KLFProfessionalModalOpenByProfessionalProfile =
function(profileId, trigger) {
  return openByProfessionalProfileId(
    profileId,
    trigger || null
  );
};

window.KLFProfessionalModalOpenByParticipant =
function(participantId, trigger) {
  return openByParticipantId(
    participantId,
    trigger || null
  );
};

window.KLFProfessionalModalClose =
function(modalOrId) {
  return closeModal(
    modalOrId,
    true
  );
};

if (!window.KLFCanonicalProfessionalModalHandoffReady) {
  window.KLFCanonicalProfessionalModalHandoffReady = true;

  document.addEventListener(
    'click',
    function(event) {

      /*
       * PROFILE IDENTITY HANDOFF
       *
       * Author / Content Creator switching is owned
       * by the shared profile-switch system.
       */
      if (
        event.target.closest(
          '[data-klf-profile-switch]'
        )
      ) {
        return;
      }

      /*
       * PROFESSIONAL -> CATALOG HANDOFF
       *
       * Catalog owns opening itself.
       * Professional only closes its own modal.
       *
       * Do NOT preventDefault.
       * Do NOT stop propagation.
       * Do NOT restore focus.
       *
       * This allows the same click to continue to
       * Catalog's canonical click handler.
       */
      var catalogTrigger =
        event.target.closest(
          '[data-professional-modal] [data-catalog-open]'
        );

      if (catalogTrigger) {
        var professionalModal =
          catalogTrigger.closest(
            '[data-professional-modal]'
          );

        if (professionalModal) {
          closeModal(
            professionalModal,
            false
          );
        }

        return;
      }

      /*
       * OPEN PROFESSIONAL PROFILE
       */
      var openTrigger =
        event.target.closest(
          '[data-open-professional-modal], ' +
          '[data-professional-profile-open]'
        );

      if (openTrigger) {
        var professionalProfileId =
          openTrigger.getAttribute(
            'data-professional-profile-id'
          ) ||
          openTrigger.getAttribute(
            'data-professional-profile-open'
          );

        var participantId =
          openTrigger.getAttribute(
            'data-participant-id'
          ) ||
          openTrigger.getAttribute(
            'data-person-id'
          );

        var opened = false;

        if (professionalProfileId) {
          opened =
            openByProfessionalProfileId(
              professionalProfileId,
              openTrigger
            );
        }

        if (!opened && participantId) {
          opened =
            openByParticipantId(
              participantId,
              openTrigger
            );
        }

        if (opened) {
          event.preventDefault();
        }

        return;
      }

      /*
       * CLOSE PROFESSIONAL PROFILE
       */
      var closeTrigger =
        event.target.closest(
          '[data-professional-modal-close]'
        );

      if (closeTrigger) {
        var modalToClose =
          closeTrigger.closest(
            '[data-professional-modal]'
          );

        if (modalToClose) {
          event.preventDefault();

          closeModal(
            modalToClose,
            true
          );
        }
      }
    }
  );

  document.addEventListener(
    'keydown',
    function(event) {
      if (event.key !== 'Escape') return;

      var openModalElement =
        document.querySelector(
          '[data-professional-modal]:not([hidden])'
        );

      if (!openModalElement) return;

      event.preventDefault();

      closeModal(
        openModalElement,
        true
      );
    }
  );
}

if (document.readyState === 'loading') {
  document.addEventListener(
    'DOMContentLoaded',
    initializeProfessionalModals,
    { once:true }
  );
} else {
  initializeProfessionalModals();
}

document.addEventListener(
  'shopify:section:load',
  initializeProfessionalModals
);

})();
